import type { ExtractedContent } from "./types";

export function contentToPlainText(content: ExtractedContent): string {
  const lines = [content.title, content.author ? `作者：${content.author}` : undefined]
    .filter(Boolean) as string[];
  lines.push(...content.textBlocks);
  if (content.images.length > 0) {
    lines.push("", "图片：", ...content.images.map((image, index) => `${index + 1}. ${image.url}`));
  }
  lines.push("", `原链接：${content.sourceUrl}`);
  return lines.join("\n").trim();
}

export function escapeHtml(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function contentToHtml(content: ExtractedContent): string {
  const title = content.title ? `<h1>${escapeHtml(content.title)}</h1>` : "";
  const author = content.author ? `<p><strong>作者：</strong>${escapeHtml(content.author)}</p>` : "";
  const body = content.textBlocks.map((block) => `<p>${escapeHtml(block)}</p>`).join("");
  const images = content.images
    .sort((a, b) => a.order - b.order)
    .map(
      (image) =>
        `<figure><img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.alt ?? "原文图片")}" /><figcaption>${escapeHtml(image.alt ?? "")}</figcaption></figure>`,
    )
    .join("");
  const source = `<p><strong>原链接：</strong><a href="${escapeHtml(content.sourceUrl)}">${escapeHtml(content.sourceUrl)}</a></p>`;
  return `<article>${title}${author}${body}${images}${source}</article>`;
}

export function draftToPlainText(title: string, sections: string[], sourceUrl: string): string {
  return [title, ...sections, "", `原链接：${sourceUrl}`].join("\n\n").trim();
}

export function draftToHtml(title: string, sections: string[], images: ExtractedContent["images"], sourceUrl: string): string {
  const body = sections.map((section) => `<p>${escapeHtml(section)}</p>`).join("");
  const media = images
    .sort((a, b) => a.order - b.order)
    .map((image) => `<p><img src="${escapeHtml(image.url)}" alt="${escapeHtml(image.alt ?? "配图")}" /></p>`)
    .join("");
  return `<article><h1>${escapeHtml(title)}</h1>${body}${media}<p><strong>原链接：</strong><a href="${escapeHtml(sourceUrl)}">${escapeHtml(sourceUrl)}</a></p></article>`;
}
